

// import { useLocation } from 'react-router-dom';
// import { useRef, useEffect, useState } from 'react';
// import html2pdf from 'html2pdf.js';
// import './bill.css';

// function formatDate(inputDate) {
//     const [year, month, day] = inputDate.split('-');
//     return `${day}-${month}-${year}`;
// }

// function getMonthName(dateStr) {
//     const dateObj = new Date(dateStr);
//     return dateObj.toLocaleString('default', { month: 'long' });
// }

// function BillPage() {
//     const location = useLocation();
//     const billRef = useRef();
//     const [monthlyTotalQty, setMonthlyTotalQty] = useState(0);

//     const billData = location.state || {};
//     const {
//         name, ph, date, time, qtyList = [], tare = 8, water = 0, netweight = 0, farmid, billno
//     } = billData;

//     useEffect(() => {
//         if (!farmid || !date) {
//             console.warn('Farm ID or date missing.');
//             return;
//         }

//         const cleanFarmId = String(farmid).trim().replace(/^"|"$/g, '');
//         const selectedMonth = date.slice(0, 7); // 'YYYY-MM'

//         fetch('https://kmtea.onrender.com/collecttea')
//             .then(res => res.json())
//             .then(data => {
//                 const monthlyData = data.filter(item => {
//                     const itemMonth = item.date.slice(0, 7); // same format
//                     return item.farmid === cleanFarmId && itemMonth === selectedMonth;
//                 });

//                 const total = monthlyData.reduce((sum, item) => sum + item.qty, 0);
//                 setMonthlyTotalQty(total);
//             })
//             .catch(err => {
//                 console.error('Failed to fetch monthly total qty', err);
//             });
//     }, [farmid, date]);

//     function roundSpecial(value) {
//         const decimalPart = value - Math.floor(value);
//         return decimalPart >= 0.75 ? Math.ceil(value) : Math.floor(value);
//     }

//     const handleDownload = () => {
//         const element = billRef.current;
//         html2pdf().set({
//             margin: 0.5,
//             filename: `Tea_Bill_${name}_${date}.pdf`,
//             image: { type: 'jpeg', quality: 0.98 },
//             html2canvas: { scale: 2 },
//             jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//         }).from(element).save();
//     };

//     const handleSendSMS = async () => {
//         const phoneStr = String(ph);
//         const formattedNumber = phoneStr.startsWith('+') ? phoneStr : `+91${phoneStr}`;
//         const formattedDate = formatDate(date);
//         const bagDetails = qtyList.join(', ');
//         const totalQty = qtyList.reduce((sum, qty) => sum + qty, 0);

//         const message = [
//             "Kammandhu ஸ்ரீ கன்னி மாரி அம்மன்",
//             `Date : ${formattedDate}`,
//             `Name : ${name}`,
//             `No. Of Bags : ${qtyList.length} - ${bagDetails}`,
//             `Total : ${totalQty} Tare : ${totalQty - netweight}kg Net total : ${netweight} kg`
//         ].join('\n');

//         try {
//             const response = await fetch('https://kmtea.onrender.com/send-sms', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ to: formattedNumber, message }),
//             });

//             const data = await response.json();
//             alert(data.success ? 'SMS sent successfully!' : 'SMS failed: ' + data.error);
//         } catch (err) {
//             alert('Error sending SMS: ' + err.message);
//         }
//     };

//     return (
//         <div className="bill-wrapper">
//             <div className="bill-format modern-card" ref={billRef}>
//                 <div className="bill-header modern-header">
//                     <p>பதிவு எண் : SRG/Ooty/15/2024</p>
//                     <h2>ஸ்ரீ கன்னிமாரியம்மன் சிறு தேயிலை விவசாயிகள் நல சங்கம்</h2>
//                     <p>"கம்மந்து"</p>
//                 </div>

//                 <div className="bill-info modern-info">
//                     <p><strong>No:</strong> {billno || '---'}</p>
//                     <p><strong>Name:</strong> {name}<br />{ph}</p>
//                     <p><strong>Date :</strong> {formatDate(date)}, {time}</p>
//                 </div>

//                 <table className="modern-table">
//                     <thead>
//                         <tr>
//                             <th>Bag No</th>
//                             <th>Qty (kg)</th>
//                             <th>Water (Kg)</th>
//                             <th>Tare (Kg)</th>
//                             <th>Net Weight (kg)</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {qtyList.map((qty, index) => {
//                             const nettare = qty - (qty * (tare / 100));
//                             return (
//                                 <tr key={index}>
//                                     <td>{index + 1}</td>
//                                     <td>{qty}</td>
//                                     <td>{water}</td>
//                                     <td>{qty - roundSpecial(nettare)}</td>
//                                     <td>{roundSpecial(nettare)}</td>
//                                 </tr>
//                             );
//                         })}
//                         <tr>
//                             <td colSpan={4}>Total</td>
//                             <td>{netweight}</td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 <h4>Grand Total ({getMonthName(date)}): {monthlyTotalQty} kg</h4>
//             </div>

//             <div className="button-group">
//                 <button className="download-btn" onClick={handleDownload}>Download</button>
//                 <button className="sms-btn" onClick={handleSendSMS}>Send SMS</button>
//             </div>
//         </div>
//     );
// }


// export default BillPage;



import { useLocation } from 'react-router-dom';
import { useRef, useEffect, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { FaSms, FaWhatsapp } from 'react-icons/fa';
import './bill.css';
import { useNavigate } from "react-router-dom";


function formatDate(inputDate) {
  if (!inputDate) return '';
  const [year, month, day] = inputDate.split('-');
  return `${day}-${month}-${year}`;
}

function getMonthName(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('default', { month: 'long' });
}

function getBillValue(tare, water, stick = 0) {
  if (water > 0 && stick === 0) return `${tare} Kg , water:${water}`;
  if (water === 0 && stick > 0) return `${tare} Kg , stick:${stick}`;
  if (water > 0 && stick > 0) return `${tare} Kg , water:${water}kg , stick:${stick}`;
  return `${tare} Kg`;
}



/* ===== Component ===== */
function BillPage() {
  const location = useLocation();
  const billRef = useRef();

  const [monthlyTotalQty, setMonthlyTotalQty] = useState(0);
  const [previewSMS, setPreviewSMS] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
const navigate = useNavigate();
  const billData = location.state || {};
  const {
    name,
    ph,
    date,
    time,
    qtyList = [],
    tare = 8,
    water = 0,
    stick = 0,
    netweight = 0,
    farmid,
    billno
  } = billData;

  /* ===== Monthly Total ===== */
  useEffect(() => {
    if (!farmid || !date) return;

    const cleanFarmId = String(farmid).trim();
    const selectedMonth = date.slice(0, 7);

    fetch('https://kmtea.onrender.com/collecttea')
      .then(res => res.json())
      .then(data => {
        const filtered = data.filter(
          d => d.farmid === cleanFarmId && d.date.slice(0, 7) === selectedMonth
        );
        const total = filtered.reduce((s, i) => s + (i.netweight || 0), 0);
        setMonthlyTotalQty(total);
      })
      .catch(err => console.error(err));
  }, [farmid, date]);


  const handlePreview = () => {
    const totalQty = qtyList.reduce((s, q) => s + q, 0);
    const billValue = getBillValue(tare, water, stick);

    const message = [
      "கம்மந்து ஸ்ரீ கன்னி மாரி அம்மன்",
      `தேதி : ${formatDate(date)}`,
      `பெயர் : ${name}`,
      `மொத்த பைகள் : ${qtyList.length} - ${qtyList.join(', ')}`,
      `மொத்த எடை : ${totalQty}kg | டேர் : ${billValue}kg | நிகர எடை : ${netweight}kg`,
      `மாத மொத்த நிகர எடை (${getMonthName(date)}-${date.slice(2, 4)}) : ${monthlyTotalQty}kg`
    ].join('\n');

    setPreviewSMS({
      ph,
      message,
      qtyList,
      totalQty,
      billValue,
      netweight,
      monthlyTotalQty
    });

    setShowPreview(true);
  };

  const sendToWhatsApp = () => {
    const phone = String(ph).replace('+91', '').trim();
    window.open(
      `https://wa.me/91${phone}?text=${encodeURIComponent(previewSMS.message)}`,
      '_blank'
    );
  };


  const sendSMSNow = async () => {
    const formattedNumber = String(ph).startsWith('+') ? ph : `+91${ph}`;
    let template_id = '';
    let variables_values = '';

    if (qtyList.length <= 5) {
      variables_values = [
        formatDate(date),
        name,
        qtyList.length,
        qtyList.join(', '),
        previewSMS.totalQty,
        previewSMS.billValue,
        netweight,
        getMonthName(date),
        date.slice(2, 4),
        monthlyTotalQty
      ].join('|');

      template_id = '194483';
    } else {
      const part = Math.ceil(qtyList.length / 3);
      const first = qtyList.slice(0, part).join(', ');
      const second = qtyList.slice(part, part * 2).join(', ');
      const third = qtyList.slice(part * 2).join(', ');

      variables_values = [
        formatDate(date),
        name,
        qtyList.length,
        first,
        second,
        third,
        previewSMS.totalQty,
        previewSMS.billValue,
        netweight,
        getMonthName(date),
        date.slice(2, 4),
        monthlyTotalQty
      ].join('|');

      template_id = '194742';
    }

    try {
      await fetch('https://kmtea.onrender.com/send-sms', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: formattedNumber,
          variables_values,
          template_id
        })
      });

      alert('SMS Sent Successfully');
    } catch (err) {
      alert('SMS Failed');
    }

    setShowPreview(false);
  };

  /* ===== PDF ===== */
  const handleDownload = () => {
    html2pdf().from(billRef.current).save(`Tea_Bill_${name}_${date}.pdf`);
  };

const handleDownloadthermal = () => {
  navigate("/billformat", {
    state: billData
  });
};

  return (
    <div className="bill-wrapper">
      <div className="bill-format modern-card" ref={billRef}>
        <div className="bill-header modern-header">
          <p>பதிவு எண் : SRG/Ooty/15/2024</p>
          <h2>ஸ்ரீ கன்னிமாரியம்மன் சிறு தேயிலை விவசாயிகள் நல சங்கம்</h2>
          <p>"கம்மந்து"</p>
        </div>

        <div className="bill-info modern-info">
          <p><strong>No:</strong> {billno || '---'}</p>
          <p><strong>Name:</strong> {name}<br />{ph}</p>
          <p><strong>Date :</strong> {formatDate(date)}, {time}</p>
        </div>


<table className="modern-table">
  <thead>
    <tr>
      <th>Bag No</th>
      <th>Qty (kg)</th>
      <th>Water (kg)</th>
      <th>Tare (kg)</th>
      <th>Net Weight (kg)</th>
    </tr>
  </thead>

  <tbody>
    {qtyList.map((qty, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{qty}</td>

        {/* ===== ROWSPAN COLUMNS ===== */}
        {index === 0 && (
          <>
            <td rowSpan={qtyList.length} className="rowspan-cell">
              {water}
            </td>
            <td rowSpan={qtyList.length} className="rowspan-cell">
              {tare}
            </td>
            <td rowSpan={qtyList.length} className="rowspan-cell">
              {netweight}
            </td>
          </>
        )}
      </tr>
    ))}

    {/* ===== TOTAL ROW ===== */}
    <tr className="total-row">
      <td><strong>Total</strong></td>
      <td></td>
      <td><strong>{water}</strong></td>
      <td><strong>{tare}</strong></td>
      <td><strong>{netweight}</strong></td>
    </tr>
  </tbody>
</table>



        <h4>Grand Total ({getMonthName(date)}): {monthlyTotalQty} kg</h4>
      </div>

      <div className="button-group">
        <button onClick={handleDownload}>Download PDF</button>
              <button onClick={handleDownloadthermal}>Thermal Print</button>
        <button onClick={handlePreview}>Send</button>
      </div>

      {/* ===== Preview Modal ===== */}
      {showPreview && previewSMS && (
        <div className="sms-preview-overlay">
          <div className="sms-preview-modal">
            <h3>Message Preview</h3>
            <pre>{previewSMS.message}</pre>
            <button onClick={sendSMSNow}><FaSms /> Send SMS</button>
            <button onClick={sendToWhatsApp}><FaWhatsapp /> WhatsApp</button>
            <button onClick={() => setShowPreview(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default BillPage;
